import { render, staticRenderFns } from "./DeviceSwitchDisabled.vue?vue&type=template&id=4ca23187&scoped=true&"
import script from "./DeviceSwitchDisabled.vue?vue&type=script&lang=js&"
export * from "./DeviceSwitchDisabled.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSwitchDisabled.vue?vue&type=style&index=0&id=4ca23187&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca23187",
  null
  
)

export default component.exports